import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AlliedservicesService } from 'src/app/services/alliedservices.service';
import {
  CATEGORY_OPTIONS,
  CATEGORY_OPTIONS_ALLIED,
  LEVEL_ALLIES,
  ORGANIZATION_TEXT_DONE,
} from 'src/app/shared/data/data';
import moment from 'moment';
import { Allied } from 'src/app/shared/data/models';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import 'moment/locale/es';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-create-allied',
  templateUrl: './create-allied.component.html',
  styleUrls: ['./create-allied.component.scss'],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'es-MXN' }],
})
export class CreateAlliedComponent implements OnInit, OnDestroy {
  private subs = new SubSink();
  public alliedLevels = LEVEL_ALLIES;
  public allieCategory = CATEGORY_OPTIONS_ALLIED;
  public typesOptionsOrganization = CATEGORY_OPTIONS;
  public levelSelected: number | null = null;
  public countrySelected: number | null = null;
  public levelValue: string | undefined = undefined;
  public hideRequiredControl = new FormControl(true);
  public newAllied: Allied;
  public notiText: string = ORGANIZATION_TEXT_DONE;
  public minDate: Date;
  public alliedForm: FormGroup = this.fb.group({
    hideRequired: this.hideRequiredControl,
    name_ally: ['', [Validators.required]],
    category: ['', [Validators.required]],
    country: ['', [Validators.required]],
    start_date: ['', [Validators.required]],
    ending_date: ['', [Validators.required]],
    ally_level: ['', [Validators.required]],
  });

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<CreateAlliedComponent>,
    private _snackBar: MatSnackBar,
    private alliedService: AlliedservicesService,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DATE_LOCALE) private _locale: string
  ) {}

  ngOnDestroy(): void {}

  ngOnInit(): void {
    this._locale = 'es';
    this._adapter.setLocale(this._locale);
    this.minDate = new Date();
  }

  private createNewOrganization(body: Allied): void {
    this.subs.sink = this.alliedService.createAllied(body).subscribe();
  }

  public getLevleAllied(id: number): void {
    this.levelSelected = id;
    this.alliedForm.controls['ally_level'].patchValue(LEVEL_ALLIES[id].level);
  }

  public chooseCountry(id: number): void {
    this.countrySelected = id;
    this.alliedForm.controls['country'].patchValue(
      CATEGORY_OPTIONS_ALLIED[id].option2
    );
  }

  public sendData(form: FormGroup): void {
    if (form.invalid) {
      this.markFormError(form);
    } else {
      let newAllied = {
        ...this.alliedForm.value,
        name_ally: form.get('name_ally')?.value,
        start_date: this.getData(form.get('start_date')?.value),
        ending_date: this.getData(form.get('ending_date')?.value),
      };
      this.createNewOrganization(newAllied);
    }
  }

  private markFormError(loginForm: FormGroup): void {
    return Object.values(loginForm.controls).forEach((control) => {
      control.markAllAsTouched();
    });
  }

  public closeForm(): void {
    this.dialogRef.close();
    this.alliedForm.reset();
  }

  public openSnackBar(): void {
    this.dialogRef.close(true);
    this._snackBar.open(`${this.notiText}`, 'Deshacer', {
      duration: 3000,
      panelClass: 'my-custom-snackbar',
    });
    this.subs.sink = this._snackBar._openedSnackBarRef
      ?.onAction()
      .subscribe(() => {
        this.alliedForm.reset();
      });

    this.subs.sink = this._snackBar._openedSnackBarRef
      ?.afterDismissed()
      .subscribe(() => {
        this.sendData(this.alliedForm);
      });
  }

  public getData(dataDate: any): string {
    return moment(dataDate).format('YYYY-MM-DD');
  }
}
